<template>
  <v-list>
    <v-list-item
      v-for="(title, titleIndex) in titles"
      :key="titleIndex"
      class="list-item"
      @click="onTitleClick(titleIndex)"
    >
      <v-list-item-title
        class="list-title"
      >
        {{ title }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'DocumentsGenerationDropdownMenu',

  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      titles: [
        this.$t('road-maintenance/documents.generate_new_document'),
        this.$t('road-maintenance/documents.choose_last_document')
      ]
    }
  },

  watch: {
    'config.hasHistoryData': {
      immediate: true,
      handler (val) {
        // if there is no documents history, show just new document generation
        if (!val) {
          this.titles.splice(this.titles.length - 1, 1)
        }
      }
    }
  },

  methods: {
    onTitleClick (index) {
      const { menuItemClick } = this.config || {}

      if (typeof menuItemClick === 'function') {
        menuItemClick({
          menuIndex: index,
          formData: this.formData
        })
      }
    }
  }
}
</script>

<style scoped>
.list-title {
  color: #111827;
  font-weight: 500;
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
}

.list-item:hover {
  cursor: pointer;
}

.list-item {
  min-height: 40px !important;
}
</style>
